'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactStyle = require('react-style');

var _reactStyle2 = _interopRequireDefault(_reactStyle);

var _style = require('./style');

var _utils = require('./utils');

var ProgressBarStyles = _reactStyle2['default'].create({
  normalStyle: {
    backgroundColor: _style.Colors.grey.P300,
    height: 4,
    overflow: 'hidden',
    position: 'relative'
  },

  progressStyle: {
    backgroundColor: _style.Colors.red.P600,
    bottom: 0,
    borderTopRightRadius: 3,
    borderBottomRightRadius: 3,
    left: 0,
    position: 'absolute',
    top: 0,
    transition: 'width .65s linear'
  },

  indeterminateBigStyle: {
    borderRadius: 3,
    width: '75%',
    left: '-75%'
  },

  indeterminateBigAnimateStyle: {
    left: '100%',
    transition: 'left .65s ease-in, width .65s ease-in'
  },

  indeteminateSmallSlowAnimateStyle: {
    width: '10%',
    transition: 'left 1.25s ease-in, width .65s ease-in'
  },

  loadingStyle: {
    position: 'relative',
    height: 4
  },

  bufferingStyle: {}
});

var _default = (function (_React$Component) {
  var _class = function _default(props) {
    _classCallCheck(this, _class);

    _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).call(this, props);
    this.state = {
      counter: 0,
      indeterminateAnimate: false
    };
  };

  _inherits(_class, _React$Component);

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this = this;

      if (this.props.type !== 'indeterminate') {
        return null;
      }
      setTimeout(function () {
        _this.setState({ indeterminateAnimate: true });
      }, 0);

      if (!_utils.transitionEnd) {
        return;
      }

      _react2['default'].findDOMNode(this.refs.progress).addEventListener(_utils.transitionEnd, this.onTransitionEnd.bind(this));
    }
  }, {
    key: 'onTransitionEnd',
    value: function onTransitionEnd(e) {
      var _this2 = this;

      if (e.propertyName !== 'left') {
        return null;
      }
      var counter = this.state.counter;
      if (counter < 3) {
        this.setState({
          indeterminateAnimate: false,
          smallSlowAnimate: false,
          counter: counter + 1
        });
        return setTimeout(function () {
          _this2.setState({ indeterminateAnimate: true });
        }, 0);
      }
      this.setState({ indeterminateAnimate: false });
      return setTimeout(function () {
        _this2.setState({
          indeterminateAnimate: true,
          smallSlowAnimate: true,
          counter: 0
        });
      }, 0);
    }
  }, {
    key: 'renderBuffer',
    value: function renderBuffer(bufferPercentage, bufferingStyle, bufferStyles) {
      if (!bufferPercentage) {
        return null;
      }

      return _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement('div', { styles: bufferingStyle }),
        _react2['default'].createElement('div', { styles: bufferStyles })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var bufferPercentage = _props.bufferPercentage;
      var percentage = _props.percentage;
      var styles = _props.styles;
      var type = _props.type;
      var _state = this.state;
      var indeterminateAnimate = _state.indeterminateAnimate;
      var smallSlowAnimate = _state.smallSlowAnimate;
      var progressStyle = ProgressBarStyles.progressStyle;
      var indeterminateBigStyle = ProgressBarStyles.indeterminateBigStyle;
      var indeterminateBigAnimateStyle = ProgressBarStyles.indeterminateBigAnimateStyle;
      var indeteminateSmallSlowAnimateStyle = ProgressBarStyles.indeteminateSmallSlowAnimateStyle;
      var normalStyle = ProgressBarStyles.normalStyle;
      var loadingStyle = ProgressBarStyles.loadingStyle;

      var progressBarStyles = [progressStyle];

      if (percentage) {
        progressBarStyles.push({ width: percentage + '%' });
      }

      if (styles) {
        progressBarStyles = progressBarStyles.concat(styles);
      }

      if (type === 'indeterminate') {
        progressBarStyles.push(indeterminateBigStyle);

        if (indeterminateAnimate) {
          progressBarStyles.push(indeterminateBigAnimateStyle);
        }

        if (smallSlowAnimate) {
          progressBarStyles.push(indeteminateSmallSlowAnimateStyle);
        }
      }

      var bufferStyles = [normalStyle, { width: bufferPercentage + '%' }];

      var ProgressStyles = bufferPercentage ? loadingStyle : normalStyle;

      return _react2['default'].createElement(
        'div',
        { styles: ProgressStyles },
        this.renderBuffer(bufferPercentage, bufferPercentage, bufferStyles),
        _react2['default'].createElement('div', {
          ref: 'progress',
          styles: progressBarStyles })
      );
    }
  }], [{
    key: 'displayName',
    value: 'ProgressBar',
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      percentage: _react.PropTypes.number,
      bufferPercentage: _react.PropTypes.number,
      styles: _react.PropTypes.array,
      type: _react.PropTypes.string
    },
    enumerable: true
  }]);

  return _class;
})(_react2['default'].Component);

exports['default'] = _default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/ProgressBar.js
 ** module id = 209
 ** module chunks = 0
 **/